<script lang="ts" setup>
defineProps({
    isSolid: {
        type: Boolean,
        default: false
    }
})
</script>

<template>
    <svg
        v-if="isSolid"
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            d="M3.53033 2.46967c-.29289-.29289-.76777-.29289-1.06066 0s-.29289.76777 0 1.06066L20.4697 21.5303c.2929.2929.7677.2929 1.0606 0 .2929-.2929.2929-.7677 0-1.0606L3.53033 2.46967ZM22.6759 12.5533c-.544 1.6354-1.4533 3.1042-2.6312 4.3094l-3.0985-3.0985c.1967-.5513.3038-1.1453.3038-1.7642 0-2.8995-2.3505-5.25-5.25-5.25-.6189 0-1.2129.1071-1.7642.30379L7.75898 4.577c1.30885-.53319 2.74082-.827 4.24152-.827 4.9703 0 9.1859 3.22272 10.675 7.6905.1204.361.1205.7517.0004 1.1128Z"
        />
        <path
            d="M15.75 12c0 .1802-.0127.3574-.0373.5308l-4.2435-4.24353C11.6426 8.2627 11.8198 8.25 12 8.25c2.0711 0 3.75 1.67893 3.75 3.75Zm-3.2193 3.7127-4.24343-4.2435C8.2627 11.6426 8.25 11.8198 8.25 12c0 2.0711 1.67893 3.75 3.75 3.75.1802 0 .3574-.0127.5307-.0373Z"
        />
        <path
            d="M6.75 12c0-.6189.1071-1.2129.30379-1.7642L3.95492 7.1369c-1.17805 1.20532-2.08745 2.67424-2.63151 4.3098-.12013.3611-.12001.7518.00033 1.1128C2.81284 17.0273 7.02847 20.25 11.9988 20.25c1.5009 0 2.933-.2939 4.242-.8272l-2.4766-2.4766c-.5513.1967-1.1453.3038-1.7642.3038-2.8995 0-5.25-2.3505-5.25-5.25Z"
        />
    </svg>

    <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M2.29289 2.29289c.39053-.39052 1.02369-.39052 1.41422 0l2.67214 2.67215C8.0418 4.03202 9.95992 3.5 12 3.5c5.2104 0 9.6091 3.46437 11.0231 8.2131.0555.1862.0555.3844.0001.5705-.6618 2.225-1.9776 4.1662-3.7233 5.6021l2.4072 2.4072c.3905.3905.3905 1.0237 0 1.4142-.3905.3905-1.0237.3905-1.4142 0L2.29289 3.70711c-.39052-.39053-.39052-1.02369 0-1.41422ZM17.8776 16.4634c1.4431-1.1384 2.5475-2.6856 3.1388-4.4647C19.76 8.22191 16.1966 5.5 12 5.5c-1.485 0-2.88873.34008-4.13928.9465l2.10746 2.10747C10.5636 8.20229 11.2586 8 12 8c2.2091 0 4 1.79086 4 4 0 .7414-.2023 1.4364-.554 2.0318l2.4316 2.4316Zm-3.9452-3.9452C13.9765 12.353 14 12.1793 14 12c0-1.1046-.8954-2-2-2-.1793 0-.353.0235-.5182.0676l2.4506 2.4506ZM4.62577 7.4591c.42165.35668.47432.98765.11764 1.40931-.77277.91353-1.37558 1.97409-1.76075 3.13289C4.23909 15.7781 7.80247 18.5 11.9991 18.5c.8997 0 1.7685-.1248 2.591-.3574.5315-.1503 1.0841.1587 1.2344.6902.1503.5314-.1587 1.0841-.6901 1.2344-.9979.2821-2.0498.4328-3.1353.4328-5.21042 0-9.60909-3.4644-11.023154-8.2131-.055424-.1862-.055453-.3844-.000085-.5705.458269-1.5407 1.230129-2.94514 2.240589-4.13966.35669-.42166.98766-.47433 1.40932-.11764Z"
            clip-rule="evenodd"
        />
    </svg>
</template>
